// TODO: The modsy-ui-kit has logic ingrained in it
// added a release valve to overwrite steps
// should rewrite progress bar, possible mimicking the
// prepurchase progress component

import {
  PREMIUM_SKUS,
  MODSY_PACKAGE_PREMIUM,
  MODSY_PACKAGE_MULTIROOM,
  LUXE_SKUS
} from 'utils/constants';

export const ALL_PPO_STEPS = {
  'room-details': {
    'renovations': 1,
    'surface-changes': 1.5,
    'architectural-changes': 1.5,
    'not-yet-built': 6,
    'heads-up': 2,
    'shapes': 3,
    'photos': 4,
    measurements: 5,
    'floor-plan': 6,
    total: 6
  },
  vision: {
    'space-usage': 1,
    'special-considerations': 2,
    brands: 3,
    'color-intensity': 4,
    'color-preferences': 5,
    furniture: 6,
    'furniture-key-pieces': 7,
    'furniture-budget': 8,
    inspiration: 9,
    urgency: 9,
    consultation: 10,
    notes: 10,
    total: 10
  },
  customProps: {
    'custom-pieces': 1,
    'additional-product': 2,
    incorporate: 3,
    summary: 4,
    checkout: 5,
    total: 5
  },
  styleQuiz: {
    rooms: 1,
    'top-rooms': 2,
    results: 3,
    total: 3
  }
};

export const LATEST_PPO_VERSION = 2;
export const ORIGINAL_PPO_VERSION = 0;
export const PREMIUM_PACKAGE_TYPES = [
  MODSY_PACKAGE_PREMIUM,
  MODSY_PACKAGE_MULTIROOM,
  ...PREMIUM_SKUS,
  ...LUXE_SKUS
];
export const CLASSIC_PACKAGE_TYPE = 'Modsy_Plus_Pckg';

export const POST_PURCHASES_ROUTES = {
  showStudio: ({ spaceId = null }) => `/studio/${spaceId}`,
  showShowroom: ({ spaceId = null }) => `/express/room-details/${spaceId}`,
  styleboardBeingProcessed: ({ spaceId = null }) => `/spaces/${spaceId}/dashboard/magic-is-happening`,
  showPPODashboard: ({ spaceId = null }) => `/spaces/${spaceId}/dashboard`,
  showProjectDashboard: ({ spaceId = null }) => `/projects/${spaceId}`,
  showLuxeLandingPage: ({ spaceId = null }) => `/project/luxe/thankyou/${spaceId}`,
  showProjectThankYou: ({ spaceId = null }) => `/project/thankyou/${spaceId}`
};

export const QUIZ_SOURCES = {
  PRE_PURCHASE: 0,
  PPO: 1,
  IOS: 2,
  ASSIGNED: 3
};
